import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Space = _resolveComponent("Space")!
  const _component_Fieldset = _resolveComponent("Fieldset")!

  return (_openBlock(), _createBlock(_component_Space, {
    vertical: "",
    xlarge: "",
    full: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.effects, (category) => {
        return (_openBlock(), _createBlock(_component_Fieldset, {
          key: category.label,
          label: category.label
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Space, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.effects, (effect) => {
                  return (_openBlock(), _createBlock(_component_Checkbox, {
                    key: effect.label,
                    name: _ctx.effects.label,
                    value: effect,
                    "model-value": _ctx.modelValue,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(effect.label), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["name", "value", "model-value"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }))
}